import styled from 'styled-components';
import { ButtonV2 } from '@getgrover/ui';

import FintecSystemsIcon from 'ggApp/shared/icons/FintecSystems';

const Wrap = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1 1 auto;
`;

const FintecIcon = styled(FintecSystemsIcon)`
    margin: 0 auto 32px;
`;

const Header = styled.h3`
    ${({ theme }) => theme.typography.SuperTinyHeadline};
    color: ${({ theme }) => theme.colors.Foreground};
    margin-bottom: 8px;
`;

const SubHeader = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
    margin-bottom: 24px;
`;

const TermsWrap = styled.div`
    display: flex;
    align-items: flex-start;
    margin-bottom: 72px;
    flex: 1 0 auto;
`;

const TermsText = styled.p`
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors.Foreground};
    & > span > a {
        color: ${({ theme }) => theme.colors.Foreground};
        text-decoration: underline;
    }
`;

const ButtonWrap = styled.div`
    display: flex;
    margin-top: auto;
`;

const BackButton = styled(ButtonV2)`
    margin-right: 16px;
    min-width: 120px;
`;

const SubmitButton = styled(ButtonV2)``;

export {
    Wrap,
    FintecIcon,
    Header,
    SubHeader,
    TermsWrap,
    TermsText,
    ButtonWrap,
    BackButton,
    SubmitButton,
}
